import React, { useEffect, useState } from 'react'
import { Button, Input, Select, DatePicker, Table } from 'antd'
import 'aos/dist/aos.css'
import '../../MainCSS.css'
import { Option } from 'antd/es/mentions'
import dayjs from 'dayjs'
import axios from 'axios'
import { toast } from 'react-toastify'
import { GetRateMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi'
import { SaveRateMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi'
import { UpdateRateMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi'
import { DeleteRateMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi'

const RateMaster = () => {
  
  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {};
  // const storedUserData = sessionStorage.getItem('userData') || '';

 const commonHeaders = {
  headers: {
    // createdBy: storedUserData || '',
    // updatedBy: storedUserData || '',
    createdBy: 1,
    updatedBy: 2,
    userIp: storedHeaders.userIp || '',
    userLat: storedHeaders.userLat || '',
    userLong: storedHeaders.userLong || '',
    deviceSign: storedHeaders.deviceSign || '',
  },
};

const commonHeaders1 = {
  headers: {
    createdBy: 1,
    updatedBy: 2,
  },
}

  const [errors, setErrors] = useState({
    date: '',
    nalcoRate: '',
    rate6063: '',
    commercialRate: '',
    rateE91E: '',
    entryDate: '',
  })

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const [rateId, setRateId] = useState('')
  const [date, setDate] = useState('')
  const [nalcoRate, setNalcoRate] = useState('')
  const [rate6063, setRate6063] = useState('')
  const [commercialRate, setCommercialRate] = useState('')
  const [rateE91E, setRateE91E] = useState('')
  const [entryDate, setEntryDate] = useState(dayjs())

  const [allRate, setAllRate] = useState([])
  const [updateButton, setUpdateButton] = useState(false)
  const [saveButton, setSaveButton] = useState(true)

  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allRate.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  // Fetch Rate Master
  let isRateFetched = false
  useEffect(() => {
    if (isRateFetched) return
    fetchRate()
    isRateFetched = true
  }, [])

  // ==============Get Table Data================

  let isError = false

  const fetchRate = async () => {
    try {
      const response = await axios.get(GetRateMaster, commonHeaders1)
      if (response.data !== null) {
        setAllRate(response.data)
        setFilteredData(response.data)
        setTotalEntries(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Rate:', error)
        toast.error('Failed to fetch Rate data')
        isError = true
      }
    }
  }

  // const columns = [
  //   {
  //     title: 'Sr.No.',
  //     dataIndex: '',
  //     key: 'index',
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: 'Date',
  //     dataIndex: 'date',
  //     key: 'date',
  //   },
  //   {
  //     title: 'Nalco Rate',
  //     dataIndex: 'nalcoRate',
  //     key: 'nalcoRate',
  //   },
  //   {
  //     title: '6063 Rate',
  //     dataIndex: 'rate6063',
  //     key: 'rate6063',
  //   },
  //   {
  //     title: 'Commercial Rate',
  //     dataIndex: 'commercialRate',
  //     key: 'commercialRate',
  //   },
  //   {
  //     title: 'E91E Rate',
  //     dataIndex: 'rateE91E',
  //     key: 'rateE91E',
  //   },
  //   {
  //     title: 'Entry Date',
  //     dataIndex: 'entryDate',
  //     key: 'entryDate',
  //   },
  //   {
  //     title: 'Actions',
  //     key: 'actions',
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
  //           onClick={() => handleDeleteData(record)}
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ]

  const columns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    sorter: (a, b) => new Date(a.date) - new Date(b.date),
  },
  {
    title: 'Nalco Rate',
    dataIndex: 'nalcoRate',
    key: 'nalcoRate',
    sorter: (a, b) => parseFloat(a.nalcoRate) - parseFloat(b.nalcoRate),
  },
  {
    title: '6063 Rate',
    dataIndex: 'rate6063',
    key: 'rate6063',
    sorter: (a, b) => parseFloat(a.rate6063) - parseFloat(b.rate6063),
  },
  {
    title: 'Commercial Rate',
    dataIndex: 'commercialRate',
    key: 'commercialRate',
    sorter: (a, b) => parseFloat(a.commercialRate) - parseFloat(b.commercialRate),
  },
  {
    title: 'E91E Rate',
    dataIndex: 'rateE91E',
    key: 'rateE91E',
    sorter: (a, b) => parseFloat(a.rateE91E) - parseFloat(b.rateE91E),
  },
  {
    title: 'Entry Date',
    dataIndex: 'entryDate',
    key: 'entryDate',
    sorter: (a, b) => new Date(a.entryDate) - new Date(b.entryDate),
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
];


  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '13px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  //=========CANCEL CONSIGNEE DATA============
  const handleCancel = () => {
    setDate('')
    setNalcoRate('')
    setRate6063('')
    setCommercialRate('')
    setRateE91E('')
    setEntryDate('')

    setUpdateButton(false)
    setSaveButton(true)
    setErrors('')
  }

  //=========SAVE CONSIGNEE DATA============
  const handleSubmit = async () => {
    let isValid = true
    const errorObj = {}

    if (!date) {
      isValid = false
      errorObj.date = 'Date is required *'
    }
    if (!nalcoRate.trim()) {
      isValid = false
      errorObj.nalcoRate = 'Nalco Rate is required *'
    }
    if (!rate6063) {
      isValid = false
      errorObj.rate6063 = '6063 Rate is required *'
    }
    if (!rateE91E) {
      isValid = false
      errorObj.rateE91E = 'E91E Rate is required *'
    }
    if (!commercialRate) {
      isValid = false
      errorObj.commercialRate = 'Commercial Rate is required *'
    }
    if (!entryDate) {
      isValid = false
      errorObj.entryDate = 'Entry Date is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return

    const formattedDate = date? dayjs(date).format('DD/MM/YYYY'): '';
    const formattedEntryDate = entryDate? dayjs(entryDate).format('DD/MM/YYYY'): '';

    const saveData = {
      date: formattedDate,
      nalcoRate: nalcoRate,
      rate6063: rate6063,
      rateE91E: rateE91E,
      commercialRate: commercialRate,
      entryDate: formattedEntryDate,
    }

    try {
      const response = await axios.post(SaveRateMaster, saveData, commonHeaders)

      if (response.data === 'CREATED') {
        toast.success('Rate added successfully!')
        fetchRate()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Rate already exist!')
        handleCancel()
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //=========EDIT CONSIGNEE DATA============
  const handleEditDataButton = (item) => {
    setUpdateButton(true)
    setSaveButton(false)

    setRateId(item.id)
    setDate(item.date ? dayjs(item.date, 'DD/MM/YYYY') : null)
    setNalcoRate(item.nalcoRate)
    setRate6063(item.rate6063)
    setRateE91E(item.rateE91E)
    setCommercialRate(item.commercialRate)
    setEntryDate(item.entryDate ? dayjs(item.entryDate, 'DD/MM/YYYY') : null)
  }

  //=========UPDATE CONSIGNEE DATA============
  const handleUpdate = async () => {
    if (
      !date ||
      !nalcoRate ||
      !rate6063 ||
      !rateE91E ||
      !commercialRate ||
      !entryDate 
    ) {
      toast.warn('Please fill all fields!')
      return
    }

    const formattedDate = date? dayjs(date).format('DD/MM/YYYY'): '';
    const formattedEntryDate = entryDate? dayjs(entryDate).format('DD/MM/YYYY'): '';

    const updateData = {
      id: rateId,
      date: formattedDate,
      nalcoRate: nalcoRate,
      rate6063: rate6063,
      rateE91E: rateE91E,
      commercialRate: commercialRate,
      entryDate: formattedEntryDate,
    }

    try {
      const response = await axios.put(
        UpdateRateMaster,
        updateData,
        commonHeaders,
      )

      if (response.data === 'UPDATED') {
        toast.success('Rate updated successfully!')
        fetchRate()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Rate already exist!')
        handleCancel()
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while updating data')
    }
  }

  //=========DELETE CONSIGNEE DATA============
  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Rate "${item.nalcoRate}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${DeleteRateMaster}?id=${item.id}`,
        commonHeaders1,
      )
      if (response.data === 'DELETED') {
        toast.success('Rate deleted successfully!')
        fetchRate()
        handleCancel()
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the Rate')
    }
  }

  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']


  return (
    <>
        <div className="px-5 py-3">
          <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
              <div className="col-12">
                <div className="row px-md-5 mt-3 p-2">
                <div className="col-md-2"></div>
                <div className="col-md-8">
                  <div className="row p-0 m-0">

                    <div className="col-md-6 py-1">
                      <label className="labels">Date</label>
                            <DatePicker
                              className="w-100"
                              format={dateFormatList}
                              value={date}
                              onChange={(value) => setDate(value)}
                            />
                            {errors.date && (
                              <div className="errorField">{errors.date}</div>
                            )}
                    </div>

                    <div className="col-md-6 py-1">
                      <label className="labels">Nalco Rate</label>
                      <Input  type="number"
                        value={nalcoRate}
                        onChange={(e) => setNalcoRate(e.target.value)}
                        placeholder="Enter Rate"
                      />
                      {errors.nalcoRate && (
                        <div className="errorField">{errors.nalcoRate}</div>
                      )}
                    </div>

                    <div className="col-md-6 py-1">
                      <label className="labels">Rate6063</label>
                      <Input  type="number"
                        value={rate6063}
                        onChange={(e) => setRate6063(e.target.value)}
                        placeholder="Enter Rate"
                      />
                      {errors.rate6063 && (
                        <div className="errorField">{errors.rate6063}</div>
                      )}
                    </div>

                    <div className="col-md-6 py-1">
                      <label className="labels">Commercial Rate</label>
                      <Input
                        type="number"
                        value={commercialRate}
                        onChange={(e) => setCommercialRate(e.target.value)}
                        placeholder="Enter Rate"
                      />
                      {errors.commercialRate && (
                        <div className="errorField">{errors.commercialRate}</div>
                      )}
                    </div>

                    <div className="col-md-6 py-1">
                      <label className="labels">RateE91E</label>
                      <Input  type="number"
                        value={rateE91E}
                        onChange={(e) => setRateE91E(e.target.value)}
                        placeholder="Enter Rate"
                      />
                      {errors.rateE91E && <div className="errorField">{errors.rateE91E}</div>}
                    </div>            

                    <div className="col-md-6 py-1">
                      <label className="labels">Entry Date</label>
                      <DatePicker
                              className="w-100"
                              format={dateFormatList}
                              value={entryDate}
                              onChange={(value) => setEntryDate(value)}
                            />
                            {errors.entryDate && (
                              <div className="errorField">{errors.entryDate}</div>
                            )}
                    </div>
                  </div>
                  </div>
                  <div className="col-md-2"></div>


                  <div className="col-12 text-center pt-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    {saveButton && (
                      <Button
                        type="submit"
                        className="SubmitBtn mx-1"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    )}
                    {updateButton && (
                      <Button
                        type="submit"
                        className="UpdateBtn mx-1"
                        onClick={handleUpdate}
                      >
                        Update
                      </Button>
                    )}
                  </div>

                  <div
                    className="col-12 p-0 mt-3"
                    style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
                  ></div>
                  
                </div>

                {/*================ Table =========================*/}
                <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
                  <div
                    className="col-12 py-3 shadow border"
                    style={{ backgroundColor: 'white' }}
                  >
                    <div
                      className="col-12 px-md-5"
                      style={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      <div>
                        <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
                        <Select
                          defaultValue={pageSize}
                          onChange={handlePageSizeChange}
                          style={{ width: 120, textAlign: 'center' }}
                        >
                          <Option value={10}>10</Option>
                          <Option value={20}>20</Option>
                          <Option value={30}>30</Option>
                        </Select>
                      </div>

                      <div className="pt-4 pt-md-0">
                        <Input.Search
                          placeholder="Search"
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{ width: 200, marginBottom: 16 }}
                        />
                      </div>
                    </div>

                    <div style={{ backgroundColor: 'white' }}>
                      <Table
                        bordered
                        style={{ padding: '0px 20px', overflowX: 'auto' }}
                        columns={columns}
                        dataSource={filteredData}
                        pagination={{
                          pageSize: pageSize,
                          total: totalEntries,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          current: currentPage,
                          onChange: (page) => setCurrentPage(page),
                        }}
                        showSorterTooltip={false}
                        rowKey={(record) => record.id}
                        components={components}
                      />
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </>
  )
}

export default RateMaster
